import React from 'react'
import { Link } from 'react-router-dom'
import { Link as SLink } from "react-scroll"
const ListHome = ({ handleMenu }) => {
    return (
        <ul>
            <SLink spy={true} to="intro" smooth={true} className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Home</li>
            </SLink>

            <SLink spy={true} to="about" smooth={true} className='hvr-underline-from-center' onClick={handleMenu}>
                <li>About</li>
            </SLink>

            <SLink spy={true} to="services" smooth={true} className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Services</li>
            </SLink>


            <Link to="/list" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>List Of House</li>
            </Link>

            <SLink spy={true} to="stats" smooth={true} className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Status</li>
            </SLink>
        </ul>
    )
}

export default ListHome